import EmptyResultsBanner from './EmptyResultsBanner'

export default EmptyResultsBanner
